import React from 'react';
import Components from './components/Components';
import Loader from "./components/Elements/Loader";

const App = () => {

  return (
    <div className="App">
      <Components />
      <Loader />
    </div>
  );
}

export default App;
